<template>
  <div class="animate-pulse">
    <div class="bg-white md:border md:rounded p-4 space-y-1 dark:bg-gray-900">
      <div class="w-full h-3 bg-shimmer rounded dark:bg-gray-850"></div>
      <div class="w-full h-3 bg-shimmer rounded dark:bg-gray-850"></div>
      <div class="w-36 h-3 bg-shimmer rounded dark:bg-gray-850"></div>
    </div>
  </div>
</template>
